/* eslint-disable max-len */
import { Link } from '@/npm/next.js';
import React from 'react';
import { Popup } from '@/npm/popup.js';
import { Purchase } from '../../../types/entities.js';
import Badge from './Badge.js';
import styles from './MultipleCustomersList.module.scss';

const Icon: any = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.icon}
  >
    <path
      d="M2.36557 14.5096C1.37408 13.4031 1.63863 11.6556 2.94659 10.9016C3.04965 8.23973 4.64435 5.85659 7.07753 4.74929C7.41451 4.40945 7.81019 4.128 8.24792 3.92133C7.87463 3.50478 7.64706 2.95502 7.64706 2.35294C7.64706 1.05553 8.70259 0 10 0C11.2974 0 12.3529 1.05553 12.3529 2.35294C12.3529 2.95502 12.1254 3.50478 11.7521 3.92133C12.1898 4.128 12.5855 4.40945 12.9225 4.74929C15.3556 5.85659 16.9504 8.23969 17.0534 10.9016C18.361 11.6554 18.6262 13.4028 17.6344 14.5096C19.0311 15.169 20 16.591 20 18.2353V20H11.7647C11.7668 18.1729 11.76 18.2109 11.7709 18.0113C10.6162 18.3101 9.38423 18.3102 8.22914 18.0113C8.23996 18.2109 8.23325 18.1733 8.23529 20H0V18.2353C0 16.591 0.968863 15.169 2.36557 14.5096ZM5.29412 12.9412C5.29412 12.2925 4.76635 11.7647 4.11765 11.7647C3.46894 11.7647 2.94118 12.2925 2.94118 12.9412C2.94118 13.5899 3.46894 14.1176 4.11765 14.1176C4.76635 14.1176 5.29412 13.5899 5.29412 12.9412ZM11.1765 2.35294C11.1765 1.70424 10.6487 1.17647 10 1.17647C9.35129 1.17647 8.82353 1.70424 8.82353 2.35294C8.82353 3.00165 9.35129 3.52941 10 3.52941C10.6487 3.52941 11.1765 3.00165 11.1765 2.35294ZM10 4.70588C8.37823 4.70588 7.05882 6.02529 7.05882 7.64706V8.23529H12.9412V7.64706C12.9412 6.02529 11.6218 4.70588 10 4.70588ZM17.0588 12.9412C17.0588 12.2925 16.5311 11.7647 15.8824 11.7647C15.2336 11.7647 14.7059 12.2925 14.7059 12.9412C14.7059 13.5899 15.2336 14.1176 15.8824 14.1176C16.5311 14.1176 17.0588 13.5899 17.0588 12.9412ZM12.9412 18.8235H18.8235V18.2353C18.8235 16.6135 17.5041 15.2941 15.8824 15.2941C14.2606 15.2941 12.9412 16.6135 12.9412 18.2353V18.8235ZM12.068 16.6847C12.4586 15.7275 13.1993 14.9491 14.1303 14.5096C13.757 14.093 13.5294 13.5433 13.5294 12.9412C13.5294 11.6539 14.5687 10.6053 15.8522 10.589C15.7105 9.1722 15.0614 7.87176 14.0518 6.91173C14.095 7.15039 14.1176 7.39612 14.1176 7.64706V9.41177H5.88235V7.64706C5.88235 7.39612 5.90498 7.15039 5.94823 6.91173C4.93859 7.87176 4.28945 9.1722 4.14776 10.589C5.43129 10.6053 6.47059 11.6539 6.47059 12.9412C6.47059 13.5433 6.24302 14.093 5.86973 14.5096C6.80071 14.9491 7.54141 15.7275 7.93196 16.6847C9.25929 17.1837 10.7392 17.1842 12.068 16.6847ZM1.17647 18.8235H7.05882V18.2353C7.05882 16.6135 5.73941 15.2941 4.11765 15.2941C2.49588 15.2941 1.17647 16.6135 1.17647 18.2353V18.8235Z"
      fill="#A0A4B5"
    />
  </svg>
);

type MultiCustomersListProps = {
  customers: Purchase['customers'];
  hasMultipleCustomers: boolean | number;
};

const MultiCustomersList: React.FC<MultiCustomersListProps> = ({
  customers,
  hasMultipleCustomers,
}) => {
  return hasMultipleCustomers ? (
    <div suppressHydrationWarning>
      {process.browser && (
        <Popup
          trigger={
            <div>
              <Badge className={styles.badge}>
                <Icon />
                <span>Совместная закупка</span>
              </Badge>
            </div>
          }
          on="hover"
          position="bottom left"
          mouseEnterDelay={300}
        >
          <div className={styles.linkList}>
            {customers.map((customer) => (
              <Link
                key={customer.shortName}
                href={`/purchases?sectionOrg=${customer.orgId}`}
              >
                {customer.shortName}
              </Link>
            ))}
          </div>
        </Popup>
      )}
    </div>
  ) : null;
};

export default MultiCustomersList;
